module.exports = __webpack_public_path__ + "img/logo-inverted.7f8d00fb.png";